<template>
    <header>
        <section class="bottom">
            <div class="bottom-title">
                <p>Cost Studies</p>
            </div>
        </section>
    </header>

    <ejs-grid ref="grid" :dataSource='grid.data' :toolbar='grid.toolbar' :toolbarClick='toolBarClickHandler' :rowDeselected="rowDeselected" :rowSelected="rowSelected" :allowSearching="true" :allowPaging="true" :allowSorting='true' :recordDoubleClick="recordDoubleClick" :allowTextWrap="true">
        <e-columns>
            <e-column field='Id' headerText='Id' :isPrimaryKey='true'></e-column>
            <e-column field='EcrNumber' headerText='ECR Number'></e-column>
            <e-column field='Name' headerText='Name' width="75%"></e-column>
        </e-columns>
    </ejs-grid>
</template>

<script>
    import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-vue-grids';
    import api from '../modules/ApiClient';
    import router from "../modules/Router";
    import Session from "../modules/Session";

    export default {
        name: 'StudiesComponent',
        props: {
            msg: String
        },
        components: {
            'ejs-grid': GridComponent,
            'e-columns': ColumnsDirective,
            'e-column': ColumnDirective
        },
        methods: {
            rowSelected: function (args) {
                this.grid.selectedRow = args.data;
            },
            rowDeselected: function () {
                this.grid.selectedRow = null;
            },
            recordDoubleClick: function (e) {
                router.push('/studies/' + e.rowData.Id);
            },
            toolBarClickHandler: function () {
                if (this.grid.selectedRow !== null) {
                    router.push('/studies/' + this.grid.selectedRow.Id);
                }
            }
        },
        data() {
            return {
                grid: {
                    data: [],
                    toolbar: [
                        { text: 'Versions', tooltipText: 'Versions', id: 'Versions', prefixIcon: 'e-grid-view' },
                        'Search'
                    ],
                    selectedRow: null
                }
            };
        },
        mounted() {
            document.title = "NCAS Reporting";

            Session.WaitToBeAuthenticated(() => {
                api.GetCostStudies().then((response) => {
                    this.grid.data = response;
                });
            });
        }
    }
</script>
